export default "__VITE_ASSET__yamDBd____"